









































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import InternalNotes from '@/components/common/inputs/InternalNotes.vue';
import { Phase, PhaseKeys } from '@/models/phase';
import Comments from '@/components/details/Comments.vue';
import IntervalSelector from '@/components/common/inputs/IntervalSelector.vue';
import FormSection from '@/components/details/FormSection.vue';
import ProcessMenu from '@/components/details/process/ProcessMenu.vue';
import ProcessHeader from '@/components/details/process/ProcessHeader.vue';
import ProcessParents from '@/components/details/process/ProcessParents.vue';
import GeneralInformationForm from '@/components/details/general-information/GeneralInformationForm.vue';
import RapidForm from '@/components/details/rapid/RapidForm.vue';
import Button from '@/components/common/inputs/Button.vue';
import ChallengesForm from '@/components/details/challenges/ChallengesForm.vue';
import AssessmentForm from '@/components/details/assessment/AssessmentForm.vue';
import ImplementationForm from '@/components/details/implementation/ImplementationForm.vue';
import TimeAndProcessForm from '@/components/details/time-process/TimeAndProcessForm.vue';
import AttachmentsForm from '@/components/details/attachments/AttachmentsForm.vue';
import OperationForm from '@/components/details/operation/OperationForm.vue';
import ArrowLeftIcon from '@/components/icons/ArrowLeftIcon.vue';
import EditIcon from '@/components/icons/EditIcon.vue';
import { ErrorState, ErrorModule } from '@/store/modules/error';
import SnackBar from '@/components/common/SnackBar.vue';
import { isEmpty } from 'lodash';
import { CommonModule } from '@/store/modules/common';
import { ProcessModule, ProcessState } from '@/store/modules/process';
import { OrganisationModule } from '@/store/modules/organisation';
import { AuthModule } from '@/store/modules/auth';
import { isIE } from '@/services/url-service';

@Component({
  components: {
    FormSection,
    ProcessMenu,
    ProcessHeader,
    ProcessParents,
    GeneralInformationForm,
    Comments,
    IntervalSelector,
    ChallengesForm,
    AssessmentForm,
    TimeAndProcessForm,
    AttachmentsForm,
    ImplementationForm,
    OperationForm,
    Button,
    ArrowLeftIcon,
    EditIcon,
    SnackBar,
    InternalNotes,
    RapidForm
  }
})
export default class Process extends Vue {
  @Prop(Boolean)
  isReporting!: boolean;
  @Prop(Number)
  id!: number;
  @Prop(String)
  phase!: Phase;

  PhaseKeys = PhaseKeys;

  showSaveSuccess = false;
  showSaveError = false;
  get state() {
    return ProcessModule;
  }

  get errors() {
    return ErrorModule;
  }

  get isWithinMunicipality() {
    return AuthModule.user?.cvr === ProcessModule.cvr;
  }

  update(state: Partial<ProcessState>) {
    ProcessModule.update(state);
  }

  clearErrors() {
    ErrorModule.clearErrors();
  }

  hashLink(target: string) {
    return `#${target}`;
  }

  clickHashLink() {
    this.$emit('clickedHashLink');
  }

  // If browser is Internet Explorer, the parent details view is nested in the search view,
  // and we have to reset the search url when hiding it.
  goBack() {
    if (isIE()) {
      this.$emit('goBack');
    }
    this.$router.push('/search');
  }

  saveComment(message: string) {
    ProcessModule.saveComment(message);
  }

  beforeCreate() {
    ErrorModule.clearErrors();
  }

  mounted() {
    OrganisationModule.loadMunicipalityDetails(AuthModule.user?.cvr? AuthModule.user.cvr : null);

    CommonModule.loadKles();
    CommonModule.loadITSystems();
    CommonModule.loadOrgUnits();

    if (this.isReporting) {
      ProcessModule.update({
        phase: this.phase,
        canEdit: true,
        hasChanged: false,
        cvr: AuthModule.user?.cvr,
        disabled: {
          rapidEdit: false,
          generalInformationEdit: false,
          challengesEdit: false,
          timeAndProcessEdit: false,
          assessmentEdit: false,
          operationEdit: false,
          implementationEdit: false,
          attachmentsEdit: false,
          internalNotesEdit: false
        }
      });
    } else {
      ProcessModule.loadComments();
    }

    CommonModule.callHighlightByUrlParam();
  }

  async save() {
    try {
      const success = await ProcessModule.save();
      this.showSaveSuccess = success;
      if (success) {
        this.clearErrors();
      }
    } catch (e) {
      this.showSaveError = true;
    }
  }

  async report() {
    try {
      const processId = await ProcessModule.createReport();
      if (!processId) {
        // if we don't get a process id back, a validation error occurred.
        return;
      }
      this.showSaveSuccess = true;
      this.clearErrors();
      this.$router.push(`/details/${processId}`);
    } catch (e) {
      this.showSaveError = true;
    }
  }
}
